module.exports = __webpack_public_path__ + "NeueFrutigerWorld-HeavyIt.0f8362b03f09690719f3.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-HeavyIt.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-HeavyIt.ttf
// module chunks = styles